import React from 'react';
import { Link } from 'react-router-dom';
import './Domain.css';

const Domain = () => {
  const domainTypes = [
    {
      icon: '🇮🇷',
      title: 'ثبت دامنه ملی ایران',
      desc: 'ثبت دامنه‌های .ir، .co.ir، .ac.ir و سایر پسوندهای ملی ایران با قیمت رقابتی و فرآیند تأیید هویت آنلاین. دامنه ملی ایران بهترین گزینه برای کسب‌وکارهای داخلی، سازمان‌ها و افرادی است که می‌خواهند هویت ایرانی خود را در فضای آنلاین حفظ کنند. با ثبت دامنه ملی، اعتماد کاربران ایرانی را جلب کرده و در نتایج جستجوی گوگل ایران جایگاه بهتری خواهید داشت.',
      features: ['قیمت رقابتی', 'تأیید هویت آنلاین', 'مدیریت DNS پیشرفته', 'پشتیبانی ۲۴/۷'],
      link: '/domain/national',
      color: '#06B6D4',
    },
    {
      icon: '🌍',
      title: 'ثبت دامنه بین‌المللی',
      desc: 'ثبت دامنه‌های .com، .net، .org و بیش از ۵۰۰ پسوند بین‌المللی با فعال‌سازی آنی و قیمت مناسب. دامنه بین‌المللی به شما امکان می‌دهد تا برند خود را در سطح جهانی معرفی کنید و مخاطبان بین‌المللی را جذب نمایید. با بیش از ۵۰۰ پسوند مختلف، می‌توانید دامنه‌ای منحصربه‌فرد برای کسب‌وکار خود انتخاب کنید.',
      features: ['بیش از ۵۰۰ پسوند', 'فعال‌سازی آنی', 'حریم خصوصی رایگان', 'قیمت مناسب'],
      link: '/domain/international',
      color: '#F97316',
    },
    {
      icon: '🔄',
      title: 'انتقال دامنه به افراسل',
      desc: 'انتقال دامنه از سایر ثبت‌کنندگان به افراسل با بهترین شرایط و بدون هزینه اضافی. با انتقال دامنه خود به افراسل، از پشتیبانی حرفه‌ای، مدیریت DNS پیشرفته و قیمت‌های رقابتی تمدید بهره‌مند شوید. فرآیند انتقال ساده و سریع است و شامل تمدید یکساله رایگان دامنه شما می‌باشد.',
      features: ['انتقال رایگان', 'تمدید یکساله', 'پشتیبانی کامل', 'مدیریت DNS پیشرفته'],
      link: '/domain/transfer',
      color: '#22C55E',
    },
  ];

  const features = [
    {
      icon: '🛡️',
      title: 'مدیریت DNS پیشرفته',
      desc: 'پنل کامل مدیریت رکوردهای DNS با قابلیت تغییر A، CNAME، MX، TXT و SRV. امکان مدیریت زیردامنه‌ها و تنظیمات پیشرفته شبکه به ساده‌ترین شکل ممکن.',
    },
    {
      icon: '⚡',
      title: 'فعال‌سازی آنی دامنه',
      desc: 'پس از ثبت دامنه، به صورت آنی فعال شده و قابل استفاده است. نیازی به انتظار برای فعال‌سازی نیست و می‌توانید بلافاصله از دامنه خود استفاده کنید.',
    },
    {
      icon: '🔄',
      title: 'انتقال رایگان دامنه',
      desc: 'انتقال دامنه از سایر ثبت‌کنندگان به افراسل بدون هیچ هزینه اضافی. به علاوه، یک سال تمدید رایگان نیز دریافت می‌کنید.',
    },
    {
      icon: '🔒',
      title: 'حریم خصوصی WHOIS',
      desc: 'محافظت از اطلاعات شخصی شما در پایگاه داده WHOIS با سرویس حریم خصوصی رایگان. اطلاعات تماس شما مخفی می‌ماند و از هرزنامه‌ها در امان خواهید بود.',
    },
  ];

  const faqs = [
    {
      q: 'ثبت دامنه ملی ایران چه شرایطی دارد و چگونه انجام می‌شود؟',
      a: 'برای ثبت دامنه با پسوند .ir و سایر پسوندهای ملی ایران، شما نیاز به ارائه مدارک شناسایی معتبر (کارت ملی یا شناسنامه) دارید. فرآیند تأیید هویت به صورت آنلاین از طریق سامانه مرکز ثبت دامنه ایران انجام می‌شود و معمولاً بین ۲۴ تا ۴۸ ساعت طول می‌کشد. نام دامنه باید با نام شخص حقیقی یا نام کسب‌وکار شما مطابقت داشته باشد. پس از تأیید هویت، دامنه شما فعال شده و می‌توانید از آن استفاده کنید.',
    },
    {
      q: 'تفاوت دامنه ملی و بین‌المللی در چیست و کدام یک برای من مناسب‌تر است؟',
      a: 'دامنه‌های ملی مانند .ir مخصوص کشور ایران هستند و برای کسب‌وکارهایی که مخاطب اصلی آنها ایرانی است، بسیار مناسب‌اند. این دامنه‌ها اعتماد کاربران ایرانی را جلب کرده و در نتایج جستجوی گوگل ایران رتبه بهتری دارند. در مقابل، دامنه‌های بین‌المللی مانند .com، .net و .org در سطح جهانی قابل استفاده هستند و محدودیت جغرافیایی ندارند. اگر قصد دارید مخاطبان بین‌المللی جذب کنید یا برند جهانی بسازید، دامنه بین‌المللی گزینه بهتری است. بسیاری از کسب‌وکارها هر دو نوع دامنه را ثبت می‌کنند تا از مزایای هر دو بهره‌مند شوند.',
    },
    {
      q: 'فرآیند انتقال دامنه به افراسل چگونه است و چقدر زمان می‌برد؟',
      a: 'برای انتقال دامنه به افراسل، ابتدا کد انتقال (Auth Code یا EPP Code) را از ثبت‌کننده فعلی خود دریافت کنید. سپس این کد را در فرم انتقال دامنه در وب‌سایت افراسل وارد کنید. پس از تأیید درخواست، فرآیند انتقال آغاز می‌شود که معمولاً بین ۱ تا ۵ روز کاری طول می‌کشد. در این مدت، دامنه شما همچنان فعال است و هیچ گونه اختلالی در دسترسی به سایت شما ایجاد نمی‌شود. تنظیمات DNS و سرورهای نام شما بدون تغییر باقی می‌مانند و کاربران شما هیچ گونه اختلالی را تجربه نمی‌کنند. پس از تکمیل انتقال، یک سال تمدید رایگان به دامنه شما اضافه می‌شود.',
    },
    {
      q: 'آیا می‌توانم تنظیمات DNS دامنه خود را خودم مدیریت کنم؟',
      a: 'بله، در پنل مدیریت دامنه افراسل، شما دسترسی کامل به تنظیمات DNS دارید. می‌توانید رکوردهای A، CNAME، MX، TXT، SRV و NS را به دلخواه تغییر دهید، زیردامنه‌های جدید ایجاد کنید و تنظیمات پیشرفته شبکه را اعمال نمایید. تغییرات DNS معمولاً در کمتر از ۱۵ دقیقه در سراسر جهان منتشر می‌شوند و شما می‌توانید به راحتی دامنه خود را به هر هاستینگ یا سرویسی متصل کنید.',
    },
  ];

  return (
    <>
      <div className="seo-header">
        <h1>ثبت و انتقال دامنه | دامنه ملی و بین‌المللی با بهترین قیمت | افراسل</h1>
        <p>ثبت دامنه‌های ملی ایران با پسوند .ir و بین‌المللی با پسوندهای .com، .net، .org و بیش از ۵۰۰ پسوند دیگر. انتقال رایگان دامنه، مدیریت DNS پیشرفته، حریم خصوصی WHOIS و پشتیبانی ۲۴ ساعته. بهترین قیمت ثبت دامنه را در افراسل تجربه کنید.</p>
        <meta name="description" content="ثبت و انتقال دامنه با بهترین قیمت در افراسل. ثبت دامنه ملی ایران (.ir، .co.ir، .ac.ir) و بین‌المللی (.com، .net، .org و ۵۰۰+ پسوند). انتقال رایگان، مدیریت DNS پیشرفته، حریم خصوصی WHOIS و پشتیبانی ۲۴/۷." />
      </div>

      <section className="domain-main-hero">
        <div className="domain-main-hero-bg"></div>
        <div className="wrap">
          <div className="domain-main-hero-content">
            <div className="domain-main-badge">
              <span className="pulse-dot"></span>
              ثبت و انتقال دامنه
            </div>
            <h1 className="domain-main-hero-title">
              دامنه <em>مورد نظر</em> خود را ثبت کنید
            </h1>
            <p className="domain-main-hero-desc">
              ثبت دامنه ملی و بین‌المللی با بهترین قیمت، انتقال رایگان و مدیریت DNS پیشرفته. 
              بیش از ۵۰۰ پسوند مختلف برای انتخاب دارید و می‌توانید دامنه خود را در کمترین زمان ثبت کنید.
              پشتیبانی ۲۴ ساعته و حریم خصوصی WHOIS رایگان از دیگر مزایای ثبت دامنه در افراسل است.
            </p>
            <div className="domain-main-hero-btns">
              <Link to="/domain/national" className="btn-lg primary">
                ثبت دامنه ملی
              </Link>
              <Link to="/domain/international" className="btn-lg ghost">
                ثبت دامنه بین‌المللی
              </Link>
              <Link to="/domain/transfer" className="btn-lg ghost" style={{ borderColor: '#22C55E', color: '#22C55E' }}>
                انتقال دامنه
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="domain-types">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">خدمات دامنه</span>
            <h2 className="sec-h">دامنه خود را <em>ثبت</em> یا <em>انتقال</em> دهید</h2>
            <p className="sec-p">همه خدمات ثبت و انتقال دامنه در یک جا با بهترین قیمت و پشتیبانی حرفه‌ای. از دامنه ملی ایران تا دامنه بین‌المللی، همه را با بهترین شرایط دریافت کنید.</p>
          </div>
          <div className="domain-types-grid">
            {domainTypes.map((type, i) => (
              <Link to={type.link} key={i} className="domain-type-card">
                <span className="domain-type-icon">{type.icon}</span>
                <h3 className="domain-type-title">{type.title}</h3>
                <p className="domain-type-desc">{type.desc}</p>
                <ul className="domain-type-features">
                  {type.features.map((feat, j) => (
                    <li key={j}><span>✓</span> {feat}</li>
                  ))}
                </ul>
                <span className="domain-type-link" style={{ color: type.color }}>
                  ثبت کنید ←
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="domain-main-features">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">مزایای ثبت دامنه در افراسل</span>
            <h2 className="sec-h">چرا <em>ثبت دامنه</em> با افراسل؟</h2>
            <p className="sec-p">ثبت و انتقال دامنه با بهترین خدمات و پشتیبانی حرفه‌ای. قیمت‌های رقابتی، فعال‌سازی آنی، مدیریت DNS پیشرفته و حریم خصوصی رایگان.</p>
          </div>
          <div className="domain-main-features-grid">
            {features.map((feature, i) => (
              <div key={i} className="domain-main-feature-card">
                <span className="domain-main-feature-icon">{feature.icon}</span>
                <h3 className="domain-main-feature-title">{feature.title}</h3>
                <p className="domain-main-feature-desc">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="domain-main-faq">
        <div className="wrap">
          <div className="sec-header">
            <span className="sec-tag">سوالات متداول</span>
            <h2 className="sec-h">پاسخ به <em>سوالات</em> شما</h2>
            <p className="sec-p">هر آنچه که باید درباره ثبت و انتقال دامنه بدانید. پاسخ سوالات رایج شما در این بخش جمع‌آوری شده است.</p>
          </div>
          <div className="domain-main-faq-grid">
            {faqs.map((faq, i) => (
              <div key={i} className="domain-main-faq-item">
                <div className="domain-main-faq-q">{faq.q}</div>
                <div className="domain-main-faq-a">{faq.a}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="domain-main-cta">
        <div className="wrap">
          <div className="cta-box">
            <h2 className="cta-title">
              دامنه <em>مورد نظر</em> خود را ثبت کنید
            </h2>
            <p className="cta-desc">
              با ثبت دامنه در افراسل، هویت آنلاین خود را بسازید. پشتیبانی ۲۴ ساعته، بهترین قیمت‌ها و 
              مدیریت DNS پیشرفته در کنار شماست. همین حالا دامنه مورد نظر خود را جستجو کنید.
            </p>
            <div className="cta-btns">
              <Link to="/domain/national" className="btn-lg primary">
                ثبت دامنه ملی
              </Link>
              <Link to="/domain/international" className="btn-lg ghost">
                ثبت دامنه بین‌المللی
              </Link>
              <Link to="/domain/transfer" className="btn-lg ghost" style={{ borderColor: '#22C55E', color: '#22C55E' }}>
                انتقال دامنه
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Domain;
